/*
 *
 * Groups reducer
 *
 */
import produce from 'immer';
import { LOAD_GROUPS_REQUEST, LOAD_GROUPS_SUCCESS, LOAD_GROUPS_FAILURE, } from './constants';
export var initialState = {
    groups: [],
    meta: {},
    loading: false,
    error: false,
};
function groupsReducer(currentState, action) {
    if (currentState === void 0) { currentState = initialState; }
    return produce(currentState, function (state) {
        switch (action.type) {
            case LOAD_GROUPS_REQUEST:
                state.loading = true;
                state.error = false;
                break;
            case LOAD_GROUPS_SUCCESS:
                state.groups = action.groups;
                state.meta = action.meta;
                state.loading = false;
                state.error = false;
                break;
            case LOAD_GROUPS_FAILURE:
                state.loading = false;
                state.error = true;
                break;
            default:
                break;
        }
    });
}
export default groupsReducer;
